(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory();else if (typeof define === 'function' && define.amd) define([], factory);else if (typeof exports === 'object') exports["BasisTranscoder"] = factory();else root["BasisTranscoder"] = factory();
})(window, function () {
  return (
    /******/
    function (modules) {
      // webpackBootstrap

      /******/
      // The module cache

      /******/
      var installedModules = {};
      /******/

      /******/
      // The require function

      /******/

      function __webpack_require__(moduleId) {
        /******/

        /******/
        // Check if module is in cache

        /******/
        if (installedModules[moduleId]) {
          /******/
          return installedModules[moduleId].exports;
          /******/
        }
        /******/
        // Create a new module (and put it into the cache)

        /******/


        var module = installedModules[moduleId] = {
          /******/
          i: moduleId,

          /******/
          l: false,

          /******/
          exports: {}
          /******/

        };
        /******/

        /******/
        // Execute the module function

        /******/

        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/

        /******/
        // Flag the module as loaded

        /******/

        module.l = true;
        /******/

        /******/
        // Return the exports of the module

        /******/

        return module.exports;
        /******/
      }
      /******/

      /******/

      /******/
      // expose the modules object (__webpack_modules__)

      /******/


      __webpack_require__.m = modules;
      /******/

      /******/
      // expose the module cache

      /******/

      __webpack_require__.c = installedModules;
      /******/

      /******/
      // define getter function for harmony exports

      /******/

      __webpack_require__.d = function (exports, name, getter) {
        /******/
        if (!__webpack_require__.o(exports, name)) {
          /******/
          Object.defineProperty(exports, name, {
            enumerable: true,
            get: getter
          });
          /******/
        }
        /******/

      };
      /******/

      /******/
      // define __esModule on exports

      /******/


      __webpack_require__.r = function (exports) {
        /******/
        if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
          /******/
          Object.defineProperty(exports, Symbol.toStringTag, {
            value: 'Module'
          });
          /******/
        }
        /******/


        Object.defineProperty(exports, '__esModule', {
          value: true
        });
        /******/
      };
      /******/

      /******/
      // create a fake namespace object

      /******/
      // mode & 1: value is a module id, require it

      /******/
      // mode & 2: merge all properties of value into the ns

      /******/
      // mode & 4: return value when already ns object

      /******/
      // mode & 8|1: behave like require

      /******/


      __webpack_require__.t = function (value, mode) {
        /******/
        if (mode & 1) value = __webpack_require__(value);
        /******/

        if (mode & 8) return value;
        /******/

        if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
        /******/

        var ns = Object.create(null);
        /******/

        __webpack_require__.r(ns);
        /******/


        Object.defineProperty(ns, 'default', {
          enumerable: true,
          value: value
        });
        /******/

        if (mode & 2 && typeof value != 'string') for (var key in value) __webpack_require__.d(ns, key, function (key) {
          return value[key];
        }.bind(null, key));
        /******/

        return ns;
        /******/
      };
      /******/

      /******/
      // getDefaultExport function for compatibility with non-harmony modules

      /******/


      __webpack_require__.n = function (module) {
        /******/
        var getter = module && module.__esModule ?
        /******/
        function getDefault() {
          return module['default'];
        } :
        /******/
        function getModuleExports() {
          return module;
        };
        /******/

        __webpack_require__.d(getter, 'a', getter);
        /******/


        return getter;
        /******/
      };
      /******/

      /******/
      // Object.prototype.hasOwnProperty.call

      /******/


      __webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/

      /******/
      // __webpack_public_path__

      /******/


      __webpack_require__.p = "";
      /******/

      /******/

      /******/
      // Load entry module and return exports

      /******/

      return __webpack_require__(__webpack_require__.s = "./src/basis/index.ts");
      /******/
    }(
    /************************************************************************/

    /******/
    {
      /***/
      "./node_modules/raw-loader/dist/cjs.js!./src/basis/worker_bundle.js":
      /*!**************************************************************************!*\
        !*** ./node_modules/raw-loader/dist/cjs.js!./src/basis/worker_bundle.js ***!
        \**************************************************************************/

      /*! exports provided: default */

      /***/
      function (module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony default export */


        __webpack_exports__["default"] = "!function(t){var e={};function n(r){if(e[r])return e[r].exports;var o=e[r]={i:r,l:!1,exports:{}};return t[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}n.m=t,n.c=e,n.d=function(t,e,r){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:r})},n.r=function(t){\"undefined\"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:\"Module\"}),Object.defineProperty(t,\"__esModule\",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&\"object\"==typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,\"default\",{enumerable:!0,value:t}),2&e&&\"string\"!=typeof t)for(var o in t)n.d(r,o,function(e){return t[e]}.bind(null,o));return r},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,\"a\",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p=\"\",n(n.s=2)}([function(t,e,n){(function(e){var n,r=(n=\"undefined\"!=typeof document&&document.currentScript?document.currentScript.src:void 0,function(t){var r,o=void 0!==(t=t||{})?t:{},i={};for(r in o)o.hasOwnProperty(r)&&(i[r]=o[r]);var a,u,s=[];a=\"object\"==typeof window,u=\"function\"==typeof importScripts,\"object\"==typeof e&&\"object\"==typeof e.versions&&e.versions.node;var c,l=\"\";(a||u)&&(u?l=self.location.href:document.currentScript&&(l=document.currentScript.src),n&&(l=n),l=0!==l.indexOf(\"blob:\")?l.substr(0,l.lastIndexOf(\"/\")+1):\"\",u&&(c=function(t){var e=new XMLHttpRequest;return e.open(\"GET\",t,!1),e.responseType=\"arraybuffer\",e.send(null),new Uint8Array(e.response)}));var f=o.print||console.log.bind(console),p=o.printErr||console.warn.bind(console);for(r in i)i.hasOwnProperty(r)&&(o[r]=i[r]);i=null,o.arguments&&(s=o.arguments),o.thisProgram&&o.thisProgram,o.quit&&o.quit;var d,h,y={\"f64-rem\":function(t,e){return t%e},debugger:function(){}};new Array(0),o.wasmBinary&&(d=o.wasmBinary),o.noExitRuntime&&o.noExitRuntime,\"object\"!=typeof WebAssembly&&p(\"no native wasm support detected\");var v,m,g,w,T,b,C,$,P,_=!1,A=\"undefined\"!=typeof TextDecoder?new TextDecoder(\"utf8\"):void 0;function F(t,e,n){for(var r=e+n,o=e;t[o]&&!(o>=r);)++o;if(o-e>16&&t.subarray&&A)return A.decode(t.subarray(e,o));for(var i=\"\";e<o;){var a=t[e++];if(128&a){var u=63&t[e++];if(192!=(224&a)){var s=63&t[e++];if((a=224==(240&a)?(15&a)<<12|u<<6|s:(7&a)<<18|u<<12|s<<6|63&t[e++])<65536)i+=String.fromCharCode(a);else{var c=a-65536;i+=String.fromCharCode(55296|c>>10,56320|1023&c)}}else i+=String.fromCharCode((31&a)<<6|u)}else i+=String.fromCharCode(a)}return i}function E(t,e){return t?F(g,t,e):\"\"}function S(t,e){return t%e>0&&(t+=e-t%e),t}function O(t){v=t,o.HEAP8=m=new Int8Array(t),o.HEAP16=w=new Int16Array(t),o.HEAP32=b=new Int32Array(t),o.HEAPU8=g=new Uint8Array(t),o.HEAPU16=T=new Uint16Array(t),o.HEAPU32=C=new Uint32Array(t),o.HEAPF32=$=new Float32Array(t),o.HEAPF64=P=new Float64Array(t)}\"undefined\"!=typeof TextDecoder&&new TextDecoder(\"utf-16le\");var W=o.TOTAL_MEMORY||16777216;function k(t){for(;t.length>0;){var e=t.shift();if(\"function\"!=typeof e){var n=e.func;\"number\"==typeof n?void 0===e.arg?o.dynCall_v(n):o.dynCall_vi(n,e.arg):n(void 0===e.arg?null:e.arg)}else e()}}(h=o.wasmMemory?o.wasmMemory:new WebAssembly.Memory({initial:W/65536}))&&(v=h.buffer),W=v.byteLength,O(v),b[59864]=5482368;var j=[],I=[],R=[],x=[],D=0,U=null,B=null;function M(t){return String.prototype.startsWith?t.startsWith(\"data:application/octet-stream;base64,\"):0===t.indexOf(\"data:application/octet-stream;base64,\")}o.preloadedImages={},o.preloadedAudios={};var N,L=\"basis_transcoder.wasm\";function V(){try{if(d)return new Uint8Array(d);if(c)return c(L);throw\"both async and sync fetching of the wasm failed\"}catch(t){Pe(t)}}function H(t){var e={env:t,wasi_unstable:t,global:{NaN:NaN,Infinity:1/0},\"global.Math\":Math,asm2wasm:y};function n(t,e){var n=t.exports;o.asm=n,function(t){if(D--,o.monitorRunDependencies&&o.monitorRunDependencies(D),0==D&&(null!==U&&(clearInterval(U),U=null),B)){var e=B;B=null,e()}}()}function r(t){n(t.instance)}function i(t){return(d||!a&&!u||\"function\"!=typeof fetch?new Promise((function(t,e){t(V())})):fetch(L,{credentials:\"same-origin\"}).then((function(t){if(!t.ok)throw\"failed to load wasm binary file at '\"+L+\"'\";return t.arrayBuffer()})).catch((function(){return V()}))).then((function(t){return WebAssembly.instantiate(t,e)})).then(t,(function(t){p(\"failed to asynchronously prepare wasm: \"+t),Pe(t)}))}if(D++,o.monitorRunDependencies&&o.monitorRunDependencies(D),o.instantiateWasm)try{return o.instantiateWasm(e,n)}catch(t){return p(\"Module.instantiateWasm callback failed with error: \"+t),!1}return function(){if(d||\"function\"!=typeof WebAssembly.instantiateStreaming||M(L)||\"function\"!=typeof fetch)return i(r);fetch(L,{credentials:\"same-origin\"}).then((function(t){return WebAssembly.instantiateStreaming(t,e).then(r,(function(t){p(\"wasm streaming compile failed: \"+t),p(\"falling back to ArrayBuffer instantiation\"),i(r)}))}))}(),{}}M(L)||(N=L,L=o.locateFile?o.locateFile(N,l):l+N),o.asm=function(t,e,n){return e.memory=h,e.table=new WebAssembly.Table({initial:342,maximum:342,element:\"anyfunc\"}),e.__memory_base=1024,e.__table_base=0,H(e)},I.push({func:function(){Ce()}});var z={},G={buffers:[null,[],[]],printChar:function(t,e){var n=G.buffers[t];0===e||10===e?((1===t?f:p)(F(n,0)),n.length=0):n.push(e)},varargs:0,get:function(t){return G.varargs+=4,b[G.varargs-4>>2]},getStr:function(){return E(G.get())},get64:function(){var t=G.get();return G.get(),t},getZero:function(){G.get()}};function q(t,e,n,r){try{for(var o=0,i=0;i<n;i++){for(var a=b[e+8*i>>2],u=b[e+(8*i+4)>>2],s=0;s<u;s++)G.printChar(t,g[a+s]);o+=u}return b[r>>2]=o,0}catch(t){return\"undefined\"!=typeof FS&&t instanceof FS.ErrnoError||Pe(t),-t.errno}}function X(t){switch(t){case 1:return 0;case 2:return 1;case 4:return 2;case 8:return 3;default:throw new TypeError(\"Unknown type size: \"+t)}}var Z=void 0;function J(t){for(var e=\"\",n=t;g[n];)e+=Z[g[n++]];return e}var Y={},K={},Q={};function tt(t){if(void 0===t)return\"_unknown\";var e=(t=t.replace(/[^a-zA-Z0-9_]/g,\"$\")).charCodeAt(0);return e>=48&&e<=57?\"_\"+t:t}function et(t,e){return t=tt(t),new Function(\"body\",\"return function \"+t+'() {\\n    \"use strict\";    return body.apply(this, arguments);\\n};\\n')(e)}function nt(t,e){var n=et(e,(function(t){this.name=e,this.message=t;var n=new Error(t).stack;void 0!==n&&(this.stack=this.toString()+\"\\n\"+n.replace(/^Error(:[^\\n]*)?\\n/,\"\"))}));return n.prototype=Object.create(t.prototype),n.prototype.constructor=n,n.prototype.toString=function(){return void 0===this.message?this.name:this.name+\": \"+this.message},n}var rt=void 0;function ot(t){throw new rt(t)}var it=void 0;function at(t){throw new it(t)}function ut(t,e,n){function r(e){var r=n(e);r.length!==t.length&&at(\"Mismatched type converter count\");for(var o=0;o<t.length;++o)st(t[o],r[o])}t.forEach((function(t){Q[t]=e}));var o=new Array(e.length),i=[],a=0;e.forEach((function(t,e){K.hasOwnProperty(t)?o[e]=K[t]:(i.push(t),Y.hasOwnProperty(t)||(Y[t]=[]),Y[t].push((function(){o[e]=K[t],++a===i.length&&r(o)})))})),0===i.length&&r(o)}function st(t,e,n){if(n=n||{},!(\"argPackAdvance\"in e))throw new TypeError(\"registerType registeredInstance requires argPackAdvance\");var r=e.name;if(t||ot('type \"'+r+'\" must have a positive integer typeid pointer'),K.hasOwnProperty(t)){if(n.ignoreDuplicateRegistrations)return;ot(\"Cannot register type '\"+r+\"' twice\")}if(K[t]=e,delete Q[t],Y.hasOwnProperty(t)){var o=Y[t];delete Y[t],o.forEach((function(t){t()}))}}function ct(t){if(!(this instanceof Ct))return!1;if(!(t instanceof Ct))return!1;for(var e=this.$$.ptrType.registeredClass,n=this.$$.ptr,r=t.$$.ptrType.registeredClass,o=t.$$.ptr;e.baseClass;)n=e.upcast(n),e=e.baseClass;for(;r.baseClass;)o=r.upcast(o),r=r.baseClass;return e===r&&n===o}function lt(t){ot(t.$$.ptrType.registeredClass.name+\" instance already deleted\")}var ft=!1;function pt(t){}function dt(t){t.count.value-=1,0===t.count.value&&function(t){t.smartPtr?t.smartPtrType.rawDestructor(t.smartPtr):t.ptrType.registeredClass.rawDestructor(t.ptr)}(t)}function ht(t){return\"undefined\"==typeof FinalizationGroup?(ht=function(t){return t},t):(ft=new FinalizationGroup((function(t){for(var e=t.next();!e.done;e=t.next()){var n=e.value;n.ptr?dt(n):console.warn(\"object already deleted: \"+n.ptr)}})),pt=function(t){ft.unregister(t.$$)},(ht=function(t){return ft.register(t,t.$$,t.$$),t})(t))}function yt(){if(this.$$.ptr||lt(this),this.$$.preservePointerOnDelete)return this.$$.count.value+=1,this;var t,e=ht(Object.create(Object.getPrototypeOf(this),{$$:{value:(t=this.$$,{count:t.count,deleteScheduled:t.deleteScheduled,preservePointerOnDelete:t.preservePointerOnDelete,ptr:t.ptr,ptrType:t.ptrType,smartPtr:t.smartPtr,smartPtrType:t.smartPtrType})}}));return e.$$.count.value+=1,e.$$.deleteScheduled=!1,e}function vt(){this.$$.ptr||lt(this),this.$$.deleteScheduled&&!this.$$.preservePointerOnDelete&&ot(\"Object already scheduled for deletion\"),pt(this),dt(this.$$),this.$$.preservePointerOnDelete||(this.$$.smartPtr=void 0,this.$$.ptr=void 0)}function mt(){return!this.$$.ptr}var gt=void 0,wt=[];function Tt(){for(;wt.length;){var t=wt.pop();t.$$.deleteScheduled=!1,t.delete()}}function bt(){return this.$$.ptr||lt(this),this.$$.deleteScheduled&&!this.$$.preservePointerOnDelete&&ot(\"Object already scheduled for deletion\"),wt.push(this),1===wt.length&&gt&&gt(Tt),this.$$.deleteScheduled=!0,this}function Ct(){}var $t={};function Pt(t,e,n){if(void 0===t[e].overloadTable){var r=t[e];t[e]=function(){return t[e].overloadTable.hasOwnProperty(arguments.length)||ot(\"Function '\"+n+\"' called with an invalid number of arguments (\"+arguments.length+\") - expects one of (\"+t[e].overloadTable+\")!\"),t[e].overloadTable[arguments.length].apply(this,arguments)},t[e].overloadTable=[],t[e].overloadTable[r.argCount]=r}}function _t(t,e,n){o.hasOwnProperty(t)?((void 0===n||void 0!==o[t].overloadTable&&void 0!==o[t].overloadTable[n])&&ot(\"Cannot register public name '\"+t+\"' twice\"),Pt(o,t,t),o.hasOwnProperty(n)&&ot(\"Cannot register multiple overloads of a function with the same number of arguments (\"+n+\")!\"),o[t].overloadTable[n]=e):(o[t]=e,void 0!==n&&(o[t].numArguments=n))}function At(t,e,n,r,o,i,a,u){this.name=t,this.constructor=e,this.instancePrototype=n,this.rawDestructor=r,this.baseClass=o,this.getActualType=i,this.upcast=a,this.downcast=u,this.pureVirtualFunctions=[]}function Ft(t,e,n){for(;e!==n;)e.upcast||ot(\"Expected null or instance of \"+n.name+\", got an instance of \"+e.name),t=e.upcast(t),e=e.baseClass;return t}function Et(t,e){if(null===e)return this.isReference&&ot(\"null is not a valid \"+this.name),0;e.$$||ot('Cannot pass \"'+oe(e)+'\" as a '+this.name),e.$$.ptr||ot(\"Cannot pass deleted object as a pointer of type \"+this.name);var n=e.$$.ptrType.registeredClass;return Ft(e.$$.ptr,n,this.registeredClass)}function St(t,e){var n;if(null===e)return this.isReference&&ot(\"null is not a valid \"+this.name),this.isSmartPointer?(n=this.rawConstructor(),null!==t&&t.push(this.rawDestructor,n),n):0;e.$$||ot('Cannot pass \"'+oe(e)+'\" as a '+this.name),e.$$.ptr||ot(\"Cannot pass deleted object as a pointer of type \"+this.name),!this.isConst&&e.$$.ptrType.isConst&&ot(\"Cannot convert argument of type \"+(e.$$.smartPtrType?e.$$.smartPtrType.name:e.$$.ptrType.name)+\" to parameter type \"+this.name);var r=e.$$.ptrType.registeredClass;if(n=Ft(e.$$.ptr,r,this.registeredClass),this.isSmartPointer)switch(void 0===e.$$.smartPtr&&ot(\"Passing raw pointer to smart pointer is illegal\"),this.sharingPolicy){case 0:e.$$.smartPtrType===this?n=e.$$.smartPtr:ot(\"Cannot convert argument of type \"+(e.$$.smartPtrType?e.$$.smartPtrType.name:e.$$.ptrType.name)+\" to parameter type \"+this.name);break;case 1:n=e.$$.smartPtr;break;case 2:if(e.$$.smartPtrType===this)n=e.$$.smartPtr;else{var o=e.clone();n=this.rawShare(n,re((function(){o.delete()}))),null!==t&&t.push(this.rawDestructor,n)}break;default:ot(\"Unsupporting sharing policy\")}return n}function Ot(t,e){if(null===e)return this.isReference&&ot(\"null is not a valid \"+this.name),0;e.$$||ot('Cannot pass \"'+oe(e)+'\" as a '+this.name),e.$$.ptr||ot(\"Cannot pass deleted object as a pointer of type \"+this.name),e.$$.ptrType.isConst&&ot(\"Cannot convert argument of type \"+e.$$.ptrType.name+\" to parameter type \"+this.name);var n=e.$$.ptrType.registeredClass;return Ft(e.$$.ptr,n,this.registeredClass)}function Wt(t){return this.fromWireType(C[t>>2])}function kt(t){return this.rawGetPointee&&(t=this.rawGetPointee(t)),t}function jt(t){this.rawDestructor&&this.rawDestructor(t)}function It(t){null!==t&&t.delete()}function Rt(){return Object.keys(Ut).length}function xt(){var t=[];for(var e in Ut)Ut.hasOwnProperty(e)&&t.push(Ut[e]);return t}function Dt(t){gt=t,wt.length&&gt&&gt(Tt)}var Ut={};function Bt(t,e){return e=function(t,e){for(void 0===e&&ot(\"ptr should not be undefined\");t.baseClass;)e=t.upcast(e),t=t.baseClass;return e}(t,e),Ut[e]}function Mt(t,e){return e.ptrType&&e.ptr||at(\"makeClassHandle requires ptr and ptrType\"),!!e.smartPtrType!=!!e.smartPtr&&at(\"Both smartPtrType and smartPtr must be specified\"),e.count={value:1},ht(Object.create(t,{$$:{value:e}}))}function Nt(t){var e=this.getPointee(t);if(!e)return this.destructor(t),null;var n=Bt(this.registeredClass,e);if(void 0!==n){if(0===n.$$.count.value)return n.$$.ptr=e,n.$$.smartPtr=t,n.clone();var r=n.clone();return this.destructor(t),r}function o(){return this.isSmartPointer?Mt(this.registeredClass.instancePrototype,{ptrType:this.pointeeType,ptr:e,smartPtrType:this,smartPtr:t}):Mt(this.registeredClass.instancePrototype,{ptrType:this,ptr:t})}var i,a=this.registeredClass.getActualType(e),u=$t[a];if(!u)return o.call(this);i=this.isConst?u.constPointerType:u.pointerType;var s=function t(e,n,r){if(n===r)return e;if(void 0===r.baseClass)return null;var o=t(e,n,r.baseClass);return null===o?null:r.downcast(o)}(e,this.registeredClass,i.registeredClass);return null===s?o.call(this):this.isSmartPointer?Mt(i.registeredClass.instancePrototype,{ptrType:i,ptr:s,smartPtrType:this,smartPtr:t}):Mt(i.registeredClass.instancePrototype,{ptrType:i,ptr:s})}function Lt(t,e,n,r,o,i,a,u,s,c,l){this.name=t,this.registeredClass=e,this.isReference=n,this.isConst=r,this.isSmartPointer=o,this.pointeeType=i,this.sharingPolicy=a,this.rawGetPointee=u,this.rawConstructor=s,this.rawShare=c,this.rawDestructor=l,o||void 0!==e.baseClass?this.toWireType=St:r?(this.toWireType=Et,this.destructorFunction=null):(this.toWireType=Ot,this.destructorFunction=null)}function Vt(t,e,n){o.hasOwnProperty(t)||at(\"Replacing nonexistant public symbol\"),void 0!==o[t].overloadTable&&void 0!==n?o[t].overloadTable[n]=e:(o[t]=e,o[t].argCount=n)}function Ht(t,e){var n;if(t=J(t),void 0!==o[\"FUNCTION_TABLE_\"+t])n=o[\"FUNCTION_TABLE_\"+t][e];else if(\"undefined\"!=typeof FUNCTION_TABLE)n=FUNCTION_TABLE[e];else{var r=o[\"dynCall_\"+t];void 0===r&&void 0===(r=o[\"dynCall_\"+t.replace(/f/g,\"d\")])&&ot(\"No dynCall invoker for signature: \"+t),n=function(n){for(var r=[],o=1;o<t.length;++o)r.push(\"a\"+o);var i=\"return function dynCall_\"+t+\"_\"+e+\"(\"+r.join(\", \")+\") {\\n\";return i+=\"    return dynCall(rawFunction\"+(r.length?\", \":\"\")+r.join(\", \")+\");\\n\",i+=\"};\\n\",new Function(\"dynCall\",\"rawFunction\",i)(n,e)}(r)}return\"function\"!=typeof n&&ot(\"unknown function pointer with signature \"+t+\": \"+e),n}var zt=void 0;function Gt(t){var e=we(t),n=J(e);return Te(e),n}function qt(t,e){var n=[],r={};throw e.forEach((function t(e){r[e]||K[e]||(Q[e]?Q[e].forEach(t):(n.push(e),r[e]=!0))})),new zt(t+\": \"+n.map(Gt).join([\", \"]))}function Xt(t,e){for(var n=[],r=0;r<t;r++)n.push(b[(e>>2)+r]);return n}function Zt(t){for(;t.length;){var e=t.pop();t.pop()(e)}}function Jt(t,e){if(!(t instanceof Function))throw new TypeError(\"new_ called with constructor type \"+typeof t+\" which is not a function\");var n=et(t.name||\"unknownFunctionName\",(function(){}));n.prototype=t.prototype;var r=new n,o=t.apply(r,e);return o instanceof Object?o:r}function Yt(t,e,n,r,o){var i=e.length;i<2&&ot(\"argTypes array size mismatch! Must at least get return value and 'this' types!\");for(var a=null!==e[1]&&null!==n,u=!1,s=1;s<e.length;++s)if(null!==e[s]&&void 0===e[s].destructorFunction){u=!0;break}var c=\"void\"!==e[0].name,l=\"\",f=\"\";for(s=0;s<i-2;++s)l+=(0!==s?\", \":\"\")+\"arg\"+s,f+=(0!==s?\", \":\"\")+\"arg\"+s+\"Wired\";var p=\"return function \"+tt(t)+\"(\"+l+\") {\\nif (arguments.length !== \"+(i-2)+\") {\\nthrowBindingError('function \"+t+\" called with ' + arguments.length + ' arguments, expected \"+(i-2)+\" args!');\\n}\\n\";u&&(p+=\"var destructors = [];\\n\");var d=u?\"destructors\":\"null\",h=[\"throwBindingError\",\"invoker\",\"fn\",\"runDestructors\",\"retType\",\"classParam\"],y=[ot,r,o,Zt,e[0],e[1]];for(a&&(p+=\"var thisWired = classParam.toWireType(\"+d+\", this);\\n\"),s=0;s<i-2;++s)p+=\"var arg\"+s+\"Wired = argType\"+s+\".toWireType(\"+d+\", arg\"+s+\"); // \"+e[s+2].name+\"\\n\",h.push(\"argType\"+s),y.push(e[s+2]);if(a&&(f=\"thisWired\"+(f.length>0?\", \":\"\")+f),p+=(c?\"var rv = \":\"\")+\"invoker(fn\"+(f.length>0?\", \":\"\")+f+\");\\n\",u)p+=\"runDestructors(destructors);\\n\";else for(s=a?1:2;s<e.length;++s){var v=1===s?\"thisWired\":\"arg\"+(s-2)+\"Wired\";null!==e[s].destructorFunction&&(p+=v+\"_dtor(\"+v+\"); // \"+e[s].name+\"\\n\",h.push(v+\"_dtor\"),y.push(e[s].destructorFunction))}return c&&(p+=\"var ret = retType.fromWireType(rv);\\nreturn ret;\\n\"),p+=\"}\\n\",h.push(p),Jt(Function,h).apply(null,y)}var Kt=[],Qt=[{},{value:void 0},{value:null},{value:!0},{value:!1}];function te(t){t>4&&0==--Qt[t].refcount&&(Qt[t]=void 0,Kt.push(t))}function ee(){for(var t=0,e=5;e<Qt.length;++e)void 0!==Qt[e]&&++t;return t}function ne(){for(var t=5;t<Qt.length;++t)if(void 0!==Qt[t])return Qt[t];return null}function re(t){switch(t){case void 0:return 1;case null:return 2;case!0:return 3;case!1:return 4;default:var e=Kt.length?Kt.pop():Qt.length;return Qt[e]={refcount:1,value:t},e}}function oe(t){if(null===t)return\"null\";var e=typeof t;return\"object\"===e||\"array\"===e||\"function\"===e?t.toString():\"\"+t}function ie(t,e){switch(e){case 2:return function(t){return this.fromWireType($[t>>2])};case 3:return function(t){return this.fromWireType(P[t>>3])};default:throw new TypeError(\"Unknown float type: \"+t)}}function ae(t,e,n){switch(e){case 0:return n?function(t){return m[t]}:function(t){return g[t]};case 1:return n?function(t){return w[t>>1]}:function(t){return T[t>>1]};case 2:return n?function(t){return b[t>>2]}:function(t){return C[t>>2]};default:throw new TypeError(\"Unknown integer type: \"+t)}}function ue(t){return t||ot(\"Cannot use deleted val. handle = \"+t),Qt[t].value}function se(t,e){var n=K[t];return void 0===n&&ot(e+\" has unknown type \"+Gt(t)),n}var ce={};function le(t){var e=ce[t];return void 0===e?J(t):e}var fe=[];function pe(){return\"object\"==typeof globalThis?globalThis:Function(\"return this\")()}var de={};function he(){return m.length}!function(){for(var t=new Array(256),e=0;e<256;++e)t[e]=String.fromCharCode(e);Z=t}(),rt=o.BindingError=nt(Error,\"BindingError\"),it=o.InternalError=nt(Error,\"InternalError\"),Ct.prototype.isAliasOf=ct,Ct.prototype.clone=yt,Ct.prototype.delete=vt,Ct.prototype.isDeleted=mt,Ct.prototype.deleteLater=bt,Lt.prototype.getPointee=kt,Lt.prototype.destructor=jt,Lt.prototype.argPackAdvance=8,Lt.prototype.readValueFromPointer=Wt,Lt.prototype.deleteObject=It,Lt.prototype.fromWireType=Nt,o.getInheritedInstanceCount=Rt,o.getLiveInheritedInstances=xt,o.flushPendingDeletes=Tt,o.setDelayFunction=Dt,zt=o.UnboundTypeError=nt(Error,\"UnboundTypeError\"),o.count_emval_handles=ee,o.get_first_emval=ne;var ye={c:Pe,A:function(t){},i:function(t){return be(t)},I:function(){throw _=!0,\"Pure virtual function called!\"},h:function(t,e,n){throw z[t]={ptr:t,adjusted:[t],type:e,destructor:n,refcount:0,caught:!1,rethrown:!1},\"uncaught_exception\"in ge?ge.uncaught_exceptions++:ge.uncaught_exceptions=1,t},z:function(){return ge.uncaught_exceptions},m:function(t){return o.___errno_location&&(b[o.___errno_location()>>2]=t),t},y:function(t,e){G.varargs=e;try{return G.getStreamFromFD(),G.get(),G.get(),G.get(),G.get(),0}catch(t){return\"undefined\"!=typeof FS&&t instanceof FS.ErrnoError||Pe(t),-t.errno}},x:function(t,e){G.varargs=e;try{return G.getStreamFromFD(),0}catch(t){return\"undefined\"!=typeof FS&&t instanceof FS.ErrnoError||Pe(t),-t.errno}},w:function(){return q.apply(null,arguments)},v:function(t,e,n,r,o){var i=X(n);st(t,{name:e=J(e),fromWireType:function(t){return!!t},toWireType:function(t,e){return e?r:o},argPackAdvance:8,readValueFromPointer:function(t){var r;if(1===n)r=m;else if(2===n)r=w;else{if(4!==n)throw new TypeError(\"Unknown boolean type size: \"+e);r=b}return this.fromWireType(r[t>>i])},destructorFunction:null})},N:function(t,e,n,r,o,i,a,u,s,c,l,f,p){l=J(l),i=Ht(o,i),u&&(u=Ht(a,u)),c&&(c=Ht(s,c)),p=Ht(f,p);var d=tt(l);_t(d,(function(){qt(\"Cannot construct \"+l+\" due to unbound types\",[r])})),ut([t,e,n],r?[r]:[],(function(e){var n,o;e=e[0],o=r?(n=e.registeredClass).instancePrototype:Ct.prototype;var a=et(d,(function(){if(Object.getPrototypeOf(this)!==s)throw new rt(\"Use 'new' to construct \"+l);if(void 0===f.constructor_body)throw new rt(l+\" has no accessible constructor\");var t=f.constructor_body[arguments.length];if(void 0===t)throw new rt(\"Tried to invoke ctor of \"+l+\" with invalid number of parameters (\"+arguments.length+\") - expected (\"+Object.keys(f.constructor_body).toString()+\") parameters instead!\");return t.apply(this,arguments)})),s=Object.create(o,{constructor:{value:a}});a.prototype=s;var f=new At(l,a,s,p,n,i,u,c),h=new Lt(l,f,!0,!1,!1),y=new Lt(l+\"*\",f,!1,!1,!1),v=new Lt(l+\" const*\",f,!1,!0,!1);return $t[t]={pointerType:y,constPointerType:v},Vt(d,a),[h,y,v]}))},M:function(t,e,n,r,o,i){var a=Xt(e,n);o=Ht(r,o),ut([],[t],(function(t){var n=\"constructor \"+(t=t[0]).name;if(void 0===t.registeredClass.constructor_body&&(t.registeredClass.constructor_body=[]),void 0!==t.registeredClass.constructor_body[e-1])throw new rt(\"Cannot register multiple constructors with identical number of parameters (\"+(e-1)+\") for class '\"+t.name+\"'! Overload resolution is currently only performed using the parameter count, not actual type info!\");return t.registeredClass.constructor_body[e-1]=function(){qt(\"Cannot construct \"+t.name+\" due to unbound types\",a)},ut([],a,(function(r){return t.registeredClass.constructor_body[e-1]=function(){arguments.length!==e-1&&ot(n+\" called with \"+arguments.length+\" arguments, expected \"+(e-1));var t=[],a=new Array(e);a[0]=i;for(var u=1;u<e;++u)a[u]=r[u].toWireType(t,arguments[u-1]);var s=o.apply(null,a);return Zt(t),r[0].fromWireType(s)},[]})),[]}))},g:function(t,e,n,r,o,i,a,u){var s=Xt(n,r);e=J(e),i=Ht(o,i),ut([],[t],(function(t){var r=(t=t[0]).name+\".\"+e;function o(){qt(\"Cannot call \"+r+\" due to unbound types\",s)}u&&t.registeredClass.pureVirtualFunctions.push(e);var c=t.registeredClass.instancePrototype,l=c[e];return void 0===l||void 0===l.overloadTable&&l.className!==t.name&&l.argCount===n-2?(o.argCount=n-2,o.className=t.name,c[e]=o):(Pt(c,e,r),c[e].overloadTable[n-2]=o),ut([],s,(function(o){var u=Yt(r,o,t,i,a);return void 0===c[e].overloadTable?(u.argCount=n-2,c[e]=u):c[e].overloadTable[n-2]=u,[]})),[]}))},L:function(t,e){st(t,{name:e=J(e),fromWireType:function(t){var e=Qt[t].value;return te(t),e},toWireType:function(t,e){return re(e)},argPackAdvance:8,readValueFromPointer:Wt,destructorFunction:null})},u:function(t,e,n){var r=X(n);st(t,{name:e=J(e),fromWireType:function(t){return t},toWireType:function(t,e){if(\"number\"!=typeof e&&\"boolean\"!=typeof e)throw new TypeError('Cannot convert \"'+oe(e)+'\" to '+this.name);return e},argPackAdvance:8,readValueFromPointer:ie(e,r),destructorFunction:null})},K:function(t,e,n,r,o,i){var a=Xt(e,n);t=J(t),o=Ht(r,o),_t(t,(function(){qt(\"Cannot call \"+t+\" due to unbound types\",a)}),e-1),ut([],a,(function(n){var r=[n[0],null].concat(n.slice(1));return Vt(t,Yt(t,r,null,o,i),e-1),[]}))},f:function(t,e,n,r,o){e=J(e),-1===o&&(o=4294967295);var i=X(n),a=function(t){return t};if(0===r){var u=32-8*n;a=function(t){return t<<u>>>u}}var s=-1!=e.indexOf(\"unsigned\");st(t,{name:e,fromWireType:a,toWireType:function(t,n){if(\"number\"!=typeof n&&\"boolean\"!=typeof n)throw new TypeError('Cannot convert \"'+oe(n)+'\" to '+this.name);if(n<r||n>o)throw new TypeError('Passing a number \"'+oe(n)+'\" from JS side to C/C++ side to an argument of type \"'+e+'\", which is outside the valid range ['+r+\", \"+o+\"]!\");return s?n>>>0:0|n},argPackAdvance:8,readValueFromPointer:ae(e,i,0!==r),destructorFunction:null})},e:function(t,e,n){var r=[Int8Array,Uint8Array,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array][e];function o(t){var e=C,n=e[t>>=2],o=e[t+1];return new r(e.buffer,o,n)}st(t,{name:n=J(n),fromWireType:o,argPackAdvance:8,readValueFromPointer:o},{ignoreDuplicateRegistrations:!0})},t:function(t,e){var n=\"std::string\"===(e=J(e));st(t,{name:e,fromWireType:function(t){var e,r=C[t>>2];if(n){var o=g[t+4+r],i=0;0!=o&&(i=o,g[t+4+r]=0);for(var a=t+4,u=0;u<=r;++u){var s=t+4+u;if(0==g[s]){var c=E(a);void 0===e?e=c:(e+=String.fromCharCode(0),e+=c),a=s+1}}0!=i&&(g[t+4+r]=i)}else{var l=new Array(r);for(u=0;u<r;++u)l[u]=String.fromCharCode(g[t+4+u]);e=l.join(\"\")}return Te(t),e},toWireType:function(t,e){e instanceof ArrayBuffer&&(e=new Uint8Array(e));var r=\"string\"==typeof e;r||e instanceof Uint8Array||e instanceof Uint8ClampedArray||e instanceof Int8Array||ot(\"Cannot pass non-string to std::string\");var o=(n&&r?function(){return function(t){for(var e=0,n=0;n<t.length;++n){var r=t.charCodeAt(n);r>=55296&&r<=57343&&(r=65536+((1023&r)<<10)|1023&t.charCodeAt(++n)),r<=127?++e:e+=r<=2047?2:r<=65535?3:4}return e}(e)}:function(){return e.length})(),i=be(4+o+1);if(C[i>>2]=o,n&&r)!function(t,e,n,r){if(!(r>0))return 0;for(var o=n+r-1,i=0;i<t.length;++i){var a=t.charCodeAt(i);if(a>=55296&&a<=57343&&(a=65536+((1023&a)<<10)|1023&t.charCodeAt(++i)),a<=127){if(n>=o)break;e[n++]=a}else if(a<=2047){if(n+1>=o)break;e[n++]=192|a>>6,e[n++]=128|63&a}else if(a<=65535){if(n+2>=o)break;e[n++]=224|a>>12,e[n++]=128|a>>6&63,e[n++]=128|63&a}else{if(n+3>=o)break;e[n++]=240|a>>18,e[n++]=128|a>>12&63,e[n++]=128|a>>6&63,e[n++]=128|63&a}}e[n]=0}(e,g,i+4,o+1);else if(r)for(var a=0;a<o;++a){var u=e.charCodeAt(a);u>255&&(Te(i),ot(\"String has UTF-16 code units that do not fit in 8 bits\")),g[i+4+a]=u}else for(a=0;a<o;++a)g[i+4+a]=e[a];return null!==t&&t.push(Te,i),i},argPackAdvance:8,readValueFromPointer:Wt,destructorFunction:function(t){Te(t)}})},J:function(t,e,n){var r,o;n=J(n),2===e?(r=function(){return T},o=1):4===e&&(r=function(){return C},o=2),st(t,{name:n,fromWireType:function(t){for(var e=r(),n=C[t>>2],i=new Array(n),a=t+4>>o,u=0;u<n;++u)i[u]=String.fromCharCode(e[a+u]);return Te(t),i.join(\"\")},toWireType:function(t,n){var i=r(),a=n.length,u=be(4+a*e);C[u>>2]=a;for(var s=u+4>>o,c=0;c<a;++c)i[s+c]=n.charCodeAt(c);return null!==t&&t.push(Te,u),u},argPackAdvance:8,readValueFromPointer:Wt,destructorFunction:function(t){Te(t)}})},H:function(t,e){st(t,{isVoid:!0,name:e=J(e),argPackAdvance:0,fromWireType:function(){},toWireType:function(t,e){}})},s:function(t,e,n){t=ue(t),e=se(e,\"emval::as\");var r=[],o=re(r);return b[n>>2]=o,e.toWireType(r,t)},r:function(t,e,n,r){(t=fe[t])(e=ue(e),n=le(n),null,r)},b:te,G:function(t){return 0===t?re(pe()):(t=le(t),re(pe()[t]))},q:function(t,e){for(var n=function(t,e,n){for(var r=new Array(t),o=0;o<t;++o)r[o]=se(b[(e>>2)+o],\"parameter \"+o);return r}(t,e),r=n[0],o=r.name+\"_$\"+n.slice(1).map((function(t){return t.name})).join(\"_\")+\"$\",i=[\"retType\"],a=[r],u=\"\",s=0;s<t-1;++s)u+=(0!==s?\", \":\"\")+\"arg\"+s,i.push(\"argType\"+s),a.push(n[1+s]);var c=\"return function \"+tt(\"methodCaller_\"+o)+\"(handle, name, destructors, args) {\\n\",l=0;for(s=0;s<t-1;++s)c+=\"    var arg\"+s+\" = argType\"+s+\".readValueFromPointer(args\"+(l?\"+\"+l:\"\")+\");\\n\",l+=n[s+1].argPackAdvance;for(c+=\"    var rv = handle[name](\"+u+\");\\n\",s=0;s<t-1;++s)n[s+1].deleteObject&&(c+=\"    argType\"+s+\".deleteObject(arg\"+s+\");\\n\");r.isVoid||(c+=\"    return retType.toWireType(destructors, rv);\\n\"),c+=\"};\\n\",i.push(c);var f,p,d=Jt(Function,i).apply(null,a);return f=d,p=fe.length,fe.push(f),p},p:function(t){return t=le(t),re(o[t])},k:function(t,e){return re((t=ue(t))[e=ue(e)])},l:function(t){t>4&&(Qt[t].refcount+=1)},o:function(t,e,n,r){t=ue(t);var i=de[e];return i||(i=function(t){for(var e=\"\",n=0;n<t;++n)e+=(0!==n?\", \":\"\")+\"arg\"+n;var r=\"return function emval_allocator_\"+t+\"(constructor, argTypes, args) {\\n\";for(n=0;n<t;++n)r+=\"var argType\"+n+\" = requireRegisteredType(Module['HEAP32'][(argTypes >> 2) + \"+n+'], \"parameter '+n+'\");\\nvar arg'+n+\" = argType\"+n+\".readValueFromPointer(args);\\nargs += argType\"+n+\"['argPackAdvance'];\\n\";return r+=\"var obj = new constructor(\"+e+\");\\nreturn __emval_register(obj);\\n}\\n\",new Function(\"requireRegisteredType\",\"Module\",\"__emval_register\",r)(se,o,re)}(e),de[e]=i),i(t,n,r)},j:function(t){return re(le(t))},n:function(t){Zt(Qt[t].value),te(t)},d:function(){o.abort()},F:he,E:function(t,e,n){g.set(g.subarray(e,e+n),t)},D:function(t){var e=he();if(t>2147418112)return!1;for(var n=Math.max(e,16777216);n<t;)n=n<=536870912?S(2*n,65536):Math.min(S((3*n+2147483648)/4,65536),2147418112);return!!function(t){try{return h.grow(t-v.byteLength+65535>>16),O(h.buffer),1}catch(t){}}(n)},C:function(){Pe(\"trap!\")},B:function(t){Pe(\"OOM\")},a:239456},ve=o.asm({},ye,v);o.asm=ve;var me,ge=o.__ZSt18uncaught_exceptionv=function(){return o.asm.O.apply(null,arguments)},we=(o.___embind_register_native_and_builtin_types=function(){return o.asm.P.apply(null,arguments)},o.___errno_location=function(){return o.asm.Q.apply(null,arguments)},o.___getTypeName=function(){return o.asm.R.apply(null,arguments)}),Te=o._free=function(){return o.asm.S.apply(null,arguments)},be=o._malloc=function(){return o.asm.T.apply(null,arguments)},Ce=o.globalCtors=function(){return o.asm.ha.apply(null,arguments)};function $e(t){function e(){me||(me=!0,_||(k(I),k(R),o.onRuntimeInitialized&&o.onRuntimeInitialized(),function(){if(o.postRun)for(\"function\"==typeof o.postRun&&(o.postRun=[o.postRun]);o.postRun.length;)t=o.postRun.shift(),x.unshift(t);var t;k(x)}()))}t=t||s,D>0||(function(){if(o.preRun)for(\"function\"==typeof o.preRun&&(o.preRun=[o.preRun]);o.preRun.length;)t=o.preRun.shift(),j.unshift(t);var t;k(j)}(),D>0||(o.setStatus?(o.setStatus(\"Running...\"),setTimeout((function(){setTimeout((function(){o.setStatus(\"\")}),1),e()}),1)):e()))}function Pe(t){throw o.onAbort&&o.onAbort(t),f(t+=\"\"),p(t),_=!0,\"abort(\"+t+\"). Build with -s ASSERTIONS=1 for more info.\"}if(o.dynCall_ii=function(){return o.asm.U.apply(null,arguments)},o.dynCall_iidiiii=function(){return o.asm.V.apply(null,arguments)},o.dynCall_iii=function(){return o.asm.W.apply(null,arguments)},o.dynCall_iiii=function(){return o.asm.X.apply(null,arguments)},o.dynCall_iiiii=function(){return o.asm.Y.apply(null,arguments)},o.dynCall_iiiiii=function(){return o.asm.Z.apply(null,arguments)},o.dynCall_iiiiiiii=function(){return o.asm._.apply(null,arguments)},o.dynCall_iiiiiiiii=function(){return o.asm.$.apply(null,arguments)},o.dynCall_jiji=function(){return o.asm.aa.apply(null,arguments)},o.dynCall_v=function(){return o.asm.ba.apply(null,arguments)},o.dynCall_vi=function(){return o.asm.ca.apply(null,arguments)},o.dynCall_vii=function(){return o.asm.da.apply(null,arguments)},o.dynCall_viiii=function(){return o.asm.ea.apply(null,arguments)},o.dynCall_viiiii=function(){return o.asm.fa.apply(null,arguments)},o.dynCall_viiiiii=function(){return o.asm.ga.apply(null,arguments)},o.asm=ve,o.then=function(t){if(me)t(o);else{var e=o.onRuntimeInitialized;o.onRuntimeInitialized=function(){e&&e(),t(o)}}return o},B=function t(){me||$e(),me||(B=t)},o.run=$e,o.abort=Pe,o.preInit)for(\"function\"==typeof o.preInit&&(o.preInit=[o.preInit]);o.preInit.length>0;)o.preInit.pop()();return $e(),t});t.exports=r}).call(this,n(1))},function(t,e){var n,r,o=t.exports={};function i(){throw new Error(\"setTimeout has not been defined\")}function a(){throw new Error(\"clearTimeout has not been defined\")}function u(t){if(n===setTimeout)return setTimeout(t,0);if((n===i||!n)&&setTimeout)return n=setTimeout,setTimeout(t,0);try{return n(t,0)}catch(e){try{return n.call(null,t,0)}catch(e){return n.call(this,t,0)}}}!function(){try{n=\"function\"==typeof setTimeout?setTimeout:i}catch(t){n=i}try{r=\"function\"==typeof clearTimeout?clearTimeout:a}catch(t){r=a}}();var s,c=[],l=!1,f=-1;function p(){l&&s&&(l=!1,s.length?c=s.concat(c):f=-1,c.length&&d())}function d(){if(!l){var t=u(p);l=!0;for(var e=c.length;e;){for(s=c,c=[];++f<e;)s&&s[f].run();f=-1,e=c.length}s=null,l=!1,function(t){if(r===clearTimeout)return clearTimeout(t);if((r===a||!r)&&clearTimeout)return r=clearTimeout,clearTimeout(t);try{r(t)}catch(e){try{return r.call(null,t)}catch(e){return r.call(this,t)}}}(t)}}function h(t,e){this.fun=t,this.array=e}function y(){}o.nextTick=function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)e[n-1]=arguments[n];c.push(new h(t,e)),1!==c.length||l||u(d)},h.prototype.run=function(){this.fun.apply(null,this.array)},o.title=\"browser\",o.browser=!0,o.env={},o.argv=[],o.version=\"\",o.versions={},o.on=y,o.addListener=y,o.once=y,o.off=y,o.removeListener=y,o.removeAllListeners=y,o.emit=y,o.prependListener=y,o.prependOnceListener=y,o.listeners=function(t){return[]},o.binding=function(t){throw new Error(\"process.binding is not supported\")},o.cwd=function(){return\"/\"},o.chdir=function(t){throw new Error(\"process.chdir is not supported\")},o.umask=function(){return 0}},function(t,e,n){\"use strict\";n.r(e);var r,o=n(0),i=n.n(o);!function(t){t[t.ASTC=0]=\"ASTC\",t[t.DXT=1]=\"DXT\",t[t.ETC=2]=\"ETC\",t[t.PVRTC=3]=\"PVRTC\",t[t.RGB565=4]=\"RGB565\"}(r||(r={}));function a(t){switch(t){case 10:return{internalformat:37808,format:0,type:0};case 2:return{internalformat:33776,format:0,type:0};case 3:return{internalformat:33779,format:0,type:0};case 0:return{internalformat:36196,format:0,type:0};case 8:return{internalformat:35840,format:0,type:0};case 9:return{internalformat:35842,format:0,type:0};case 14:return{internalformat:6407,format:6407,type:33635}}}const u=self;const s=new class{constructor(){this.promise=new Promise((t,e)=>{this.resolve=t,this.reject=e})}};async function c(t){const e=await s.promise,{BasisFile:n}=e,o=new n(new Uint8Array(t.payload.basisFile));function i(e){o.close(),o.delete(),l(t,{error:e,images:[]})}const u=o.getNumImages(),c=!!o.getHasAlpha(),f=function(t,e){switch(t){case r.ASTC:return 10;case r.DXT:return e?3:2;case r.PVRTC:return e?9:8;case r.ETC:return 0;case r.RGB565:return 14}}(t.payload.outputFormat,c);if(!o.startTranscoding())return void i(\"startTranscoding failed\");const p=[];for(let t=0;t<u;t++){const e=o.getImageWidth(t,0),n=o.getImageHeight(t,0),r=o.getNumLevels(0),u=[];for(let e=0;e<r;e++){const n=o.getImageWidth(t,e)+3&-4,r=o.getImageHeight(t,e)+3&-4,a=o.getImageTranscodedSizeInBytes(t,e,f),s=new ArrayBuffer(a);if(!o.transcodeImage(new Uint8Array(s),t,e,f,0,!1))return void i(\"transcodeImage failed\");const c={alignedWidth:n,alignedHeight:r,data:s};u.push(c)}const s={alpha:c,width:e,height:n,levels:u,format:a(f)};p.push(s)}o.close(),o.delete(),l(t,{images:p})}function l(t,e){const n={uid:t.uid,type:3,payload:e},r=function(t){const e=[];for(const n of t.images)for(const t of n.levels)e.push(t.data);return e}(e);u.postMessage(n,r)}u.addEventListener(\"message\",t=>{const e=t.data;switch(e.type){case 0:!async function(t){const e={wasmBinary:t.payload};i()(e).then(t=>{s.resolve({BasisFile:t.BasisFile,initializeBasis:t.initializeBasis})}),(await s.promise).initializeBasis(),u.postMessage({uid:\"\",type:1,payload:!0})}(e);break;case 2:c(e)}})}]);";
        /***/
      },

      /***/
      "./src/basis/BasisRequest.ts":
      /*!***********************************!*\
        !*** ./src/basis/BasisRequest.ts ***!
        \***********************************/

      /*! exports provided: BasisOutputFormat */

      /***/
      function (module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "BasisOutputFormat", function () {
          return BasisOutputFormat;
        });

        var BasisOutputFormat;

        (function (BasisOutputFormat) {
          BasisOutputFormat[BasisOutputFormat["ASTC"] = 0] = "ASTC";
          BasisOutputFormat[BasisOutputFormat["DXT"] = 1] = "DXT";
          BasisOutputFormat[BasisOutputFormat["ETC"] = 2] = "ETC";
          BasisOutputFormat[BasisOutputFormat["PVRTC"] = 3] = "PVRTC";
          BasisOutputFormat[BasisOutputFormat["RGB565"] = 4] = "RGB565";
        })(BasisOutputFormat || (BasisOutputFormat = {}));
        /***/

      },

      /***/
      "./src/basis/BasisTranscoderPool.ts":
      /*!******************************************!*\
        !*** ./src/basis/BasisTranscoderPool.ts ***!
        \******************************************/

      /*! exports provided: BasisTranscoderPool */

      /***/
      function (module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "BasisTranscoderPool", function () {
          return BasisTranscoderPool;
        });
        /* harmony import */


        var raw_loader_basis_worker_bundle_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! raw-loader!basis/worker_bundle.js */
        "./node_modules/raw-loader/dist/cjs.js!./src/basis/worker_bundle.js"); //@ts-ignore


        let BasisTranscoderBinary = null;

        class Deferred {
          constructor() {
            this.promise = new Promise((resolve, reject) => {
              this.resolve = resolve;
              this.reject = reject;
            });
          }

        }

        function createWorker() {
          let blob;

          try {
            blob = new Blob([raw_loader_basis_worker_bundle_js__WEBPACK_IMPORTED_MODULE_0__["default"]], {
              type: 'application/javascript'
            });
          } catch (e) {
            //@ts-ignore
            const BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder;
            const blobBuilder = new BlobBuilder();
            blobBuilder.append(raw_loader_basis_worker_bundle_js__WEBPACK_IMPORTED_MODULE_0__["default"]);
            blob = blobBuilder.getBlob();
          }

          const datauri = URL.createObjectURL(blob);
          const worker = new Worker(datauri);
          URL.revokeObjectURL(datauri);
          return worker;
        }

        async function fetchBasisWasm(path) {
          if (BasisTranscoderBinary === null) {
            const response = await fetch(path);
            BasisTranscoderBinary = await response.arrayBuffer();
          }

          return BasisTranscoderBinary;
        }

        class WorkerRequest {
          constructor(basis) {
            this.id = '' + WorkerRequest.UID++;
            this._defered = new Deferred();
            this.basisFile = basis;
          }

          async response() {
            return this._defered.promise;
          }

        }

        WorkerRequest.UID = 0;

        class BasisTranscoderWorker {
          constructor() {
            this._initDeferred = null;
            this._status = 0
            /* UNINITIALIZED */
            ;

            this._onMessage = event => {
              const msg = event.data;

              switch (msg.type) {
                case 1
                /* INIT_RESPONSE */
                :
                  this._initDeferred.resolve();

                  break;

                case 3
                /* TRANSCODE_RESPONSE */
                :
                  this._handleTranscodeResponse(msg);

                  break;

                default:
                  throw `unknown message ${msg.type}`;
              }
            };

            this._requests = new Map();
            this._initDeferred = new Deferred();
            this.worker = createWorker();
            this.worker.addEventListener("message", this._onMessage);
          }

          async init(wasm) {
            this._postMessage({
              type: 0
              /* INIT_REQUEST */
              ,
              payload: wasm,
              uid: ''
            });

            return this._initDeferred.promise;
          }

          async transcode(basisFile, outputFormat) {
            const req = new WorkerRequest(basisFile);

            this._requests.set(req.id, req);

            this._postMessage({
              type: 2
              /* TRANSCODE_REQUEST */
              ,
              payload: {
                basisFile,
                outputFormat
              },
              uid: req.id
            }, [basisFile]);

            return req.response();
          }

          _postMessage(m, transferables) {
            this.worker.postMessage(m, transferables);
          }

          _handleTranscodeResponse(msg) {
            const deferred = this._requests.get(msg.uid)._defered;

            if (msg.payload.error) {
              deferred.reject(msg.payload.error);
            } else {
              deferred.resolve(msg.payload);
            }

            this._requests.delete(msg.uid);
          }

        }

        class BasisTranscoderPool {
          constructor(wasmBinaryPath) {
            this.maxWorkers = 1;
            this._transcoders = [];
            this._available = [];
            this._pendingRequests = [];
            this._wasmBinaryPath = wasmBinaryPath;
          }
          /*
          * Provide available transcoder
          * return unused transcoder if exist
          * create new one if maxWorker not yet reached
          * otherwise enqueue request
          */


          async getTranscoder() {
            if (this._available.length > 0) {
              return this._available.pop();
            }

            if (this._transcoders.length < this.maxWorkers) {
              const t = new BasisTranscoderWorker();

              this._transcoders.push(t);

              const wasmBinary = await fetchBasisWasm(this._wasmBinaryPath);
              t.init(wasmBinary);
              return t;
            }

            const request = new Deferred();

            this._pendingRequests.push(request);

            return request.promise;
          }

          releaseTranscoder(transcoder) {
            this._makeAvailable(transcoder);
          }
          /*
          * call whenever a trancoder became available
          * if pending request exist, transfert it directly
          * else push transcoder back to _available stack
          */


          _makeAvailable(transcoder) {
            // console.log("make available", this._pendingRequests);
            if (this._pendingRequests.length > 0) {
              // console.log("resolve pending trancoder");
              this._pendingRequests.shift().resolve(transcoder);
            } else {
              this._available.push(transcoder);
            }
          }

        }
        /***/

      },

      /***/
      "./src/basis/index.ts":
      /*!****************************!*\
        !*** ./src/basis/index.ts ***!
        \****************************/

      /*! exports provided: default */

      /***/
      function (module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return BasisTranscoder;
        });
        /* harmony import */


        var _BasisTranscoderPool__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./BasisTranscoderPool */
        "./src/basis/BasisTranscoderPool.ts");
        /* harmony import */


        var _BasisRequest__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! ./BasisRequest */
        "./src/basis/BasisRequest.ts");

        class BasisTranscoder {
          constructor(wasmBinaryPath) {
            this._transcoderPool = new _BasisTranscoderPool__WEBPACK_IMPORTED_MODULE_0__["BasisTranscoderPool"](wasmBinaryPath);
          }

          async transcode(basisFile, outputFormat) {
            const worker = await this._transcoderPool.getTranscoder();

            try {
              const result = await worker.transcode(basisFile, outputFormat);

              this._transcoderPool.releaseTranscoder(worker);

              return result;
            } finally {
              this._transcoderPool.releaseTranscoder(worker);
            }
          }

        }

        BasisTranscoder.BasisOutputFormat = _BasisRequest__WEBPACK_IMPORTED_MODULE_1__["BasisOutputFormat"]; // transcoder.terminate();

        /*
        abort
        arguments
        asm
        BindingError
        count_emval_handles
        dynCall_ii
        dynCall_iidiiii
        dynCall_iii
        dynCall_iiii
        dynCall_iiiii
        dynCall_iiiiii
        dynCall_iiiiiiii
        dynCall_iiiiiiiii
        dynCall_jiji
        dynCall_v
        dynCall_vi
        dynCall_vii
        dynCall_viiii
        dynCall_viiiii
        dynCall_viiiiii
        flushPendingDeletes
        getInheritedInstanceCount
        getLiveInheritedInstances
        get_first_emval
        globalCtors
        HEAP16
        HEAP32
        HEAP8
        HEAPF32
        HEAPF64
        HEAPU16
        HEAPU32
        HEAPU8
        instantiateWasm
        InternalError
        locateFile
        monitorRunDependencies
        noExitRuntime
        onAbort
        onRuntimeInitialized
        postRun
        preInit
        preloadedAudios
        preloadedImages
        preRun
        print
        printErr
        quit
        run
        setDelayFunction
        setStatus
        then
        thisProgram
        TOTAL_MEMORY
        UnboundTypeError
        wasmBinary
        wasmMemory
        _free
        _malloc
        __ZSt18uncaught_exceptionv
        ___embind_register_native_and_builtin_types
        ___errno_location
        ___getTypeName
        */

        /***/
      }
      /******/

    })["default"]
  );
});